import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export default function useGetColors() {
  const theme = useSelector((state: RootState) => state.ui.theme);

  return { ...useTheme().palette, ...theme };
}
